/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Sendinvites2Inputs */

const zh_organizationsettings_sendinvites2 = /** @type {(inputs: Organizationsettings_Sendinvites2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送邀请`)
};

const en_organizationsettings_sendinvites2 = /** @type {(inputs: Organizationsettings_Sendinvites2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Invites`)
};

const es_organizationsettings_sendinvites2 = /** @type {(inputs: Organizationsettings_Sendinvites2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar invitaciones`)
};

/**
* | output |
* | --- |
* | "Send Invites" |
*
* @param {Organizationsettings_Sendinvites2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_sendinvites2 = /** @type {((inputs?: Organizationsettings_Sendinvites2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Sendinvites2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_sendinvites2(inputs)
	if (locale === "en") return en_organizationsettings_sendinvites2(inputs)
	return es_organizationsettings_sendinvites2(inputs)
});
export { organizationsettings_sendinvites2 as "organizationSettings_sendInvites" }